import axios from "axios";
import { API_PATHS } from "../paths";
import { flashMessage } from "../../utils/flashMessageService";

/**
 * POST /api/contactus
 */
export async function submitContactUs(payload = {}) {
  try {
    const body = payload || {};

    const response = await axios.post(API_PATHS.contactUs, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("submitContactUs failed with status 400:", error.response.data);
      flashMessage(`submitContactUs failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error submitting contact request:", error);
      flashMessage("submitContactUs failed. Please try again.", { type: "error" });
    }
    throw error;
  }
}
